import script from "./EmbededPogressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmbededPogressBar.vue?vue&type=script&setup=true&lang=ts"

import "./EmbededPogressBar.vue?vue&type=style&index=0&id=2f6869a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f6869a7"]])

export default __exports__